import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { router } from './router'
import App from './App.vue'

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import global styles
import './assets/styles/main.scss'

// Check for auth data in URL hash (for MyGeotab Add-In integration)
function checkAuthFromHash() {
  const hash = window.location.hash

  // Check if hash contains auth data (#auth=...)
  if (hash && hash.startsWith('#auth=')) {
    try {
      // Extract auth data from hash
      const authDataEncoded = hash.substring(6) // Remove '#auth='
      const authDataJson = decodeURIComponent(authDataEncoded)
      const authData = JSON.parse(authDataJson)

      console.log('Auth data found in URL hash, storing in localStorage')

      // Store in localStorage
      if (authData.token) {
        localStorage.setItem('token', authData.token)
      }

      if (authData.user) {
        localStorage.setItem('user', JSON.stringify(authData.user))
      }

      // Clean the hash from URL
      window.location.hash = ''

      console.log('Token stored successfully from hash')
    } catch (error) {
      console.error('Error parsing auth data from hash:', error)
    }
  }
}

// Check for auth in hash before creating app
checkAuthFromHash()

// Create Vue app
const app = createApp(App)

// Use Pinia for state management
app.use(createPinia())

// Use Vue Router
app.use(router)

// Mount the app
app.mount('#app')